<ng-container *ngIf="viewModel$ | async as viewModel">
  <section class="inventory-list">
    <div class="inventory-content">
      <div *ngIf="!viewModel.jobInCurrentZone" class="shared-job-overlay"></div>
      <div *ngIf="viewModel.inventoryNotes" class="inventory-notes">
        <h2>Legacy Inventory Notes:</h2>
        <span>
          {{ viewModel.inventoryNotes }}
        </span>
      </div>

      <div class="inventory-header">
        <h2>Inventory</h2>
        <div class="button-list">
          <p-button
            label="Add Room"
            icon="pi pi-plus"
            [outlined]="true"
            (click)="store.dispatch(actions.addRoomButtonClicked())"
          ></p-button>

          <ng-container *ngIf="yemboHelper.yemboEnabled">
            <p-button
              *ngIf="
                viewModel.isYemboMoveCreated;
                else bookSmartConsultSplitButton
              "
              icon="pi pi-external-link"
              label="View Move in Yembo"
              (onClick)="store.dispatch(actions.viewMoveInYemboButtonClicked())"
            />
          </ng-container>

          <ng-container *ngIf="viewModel.qubeSheetsEnabled">
            <p-button
              *ngIf="
                viewModel.qubeSheetsProjectId;
                else bookVideoCallButton
              "
              icon="pi pi-external-link"
              label="View Qube Sheets Project"
              (onClick)="
                store.dispatch(actions.viewQubeSheetsProjectButtonClicked())
              "
            />
          </ng-container>
        </div>
      </div>

      <table class="inventory">
        <thead>
          <tr>
            <th class="inventory-name">Item</th>
            <th class="inventory-value hidden-sm">Quantity</th>
            <th class="inventory-value hidden-sm">Weight</th>
            <th class="inventory-value hidden-sm">Volume</th>
            <th class="inventory-value show-sm">
              Quantity<br />Volume<br />Weight
            </th>
            <th><!-- Expand/Collapse --></th>
            <th><!-- Actions --></th>
          </tr>
        </thead>
        <tbody>
          <ng-container
            *ngFor="let room of viewModel.rooms; trackBy: trackByRoomId"
          >
            <tr class="room">
              <td class="p-d-flex">
                <app-edit-in-place
                  [value]="room.name"
                  (saveButtonPressed)="
                    store.dispatch(
                      actions.editRoomNameInPlaceConfirmButtonClicked({
                        roomId: room.id,
                        name: $event.value,
                      })
                    );
                    $event.deactivate()
                  "
                ></app-edit-in-place>
              </td>

              <td class="inventory-value hidden-sm">
                {{ room.totalItems || 0 }}
              </td>
              <td class="inventory-value hidden-sm">
                {{ room.totalWeight || 0 }}{{ viewModel.weightUnit }}
              </td>
              <td class="inventory-value hidden-sm">
                {{ room.totalVolume || 0 }}{{ viewModel.volumeUnit }}
              </td>
              <td class="inventory-value show-sm">
                {{ room.totalItems || 0 }}<br />
                {{ room.totalWeight }}{{ viewModel.weightUnit }}<br />
                {{ room.totalVolume }}{{ viewModel.volumeUnit }}
              </td>
              <td class="inventory-value">
                <p-button
                  [attr.aria-label]="
                    room.isCollapsed ? 'Expand room' : 'Collapse room'
                  "
                  [icon]="
                    room.isCollapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-up'
                  "
                  [rounded]="true"
                  [text]="true"
                  (click)="
                    store.dispatch(
                      actions.toggleCollapseRoomButtonClicked({
                        roomId: room.id,
                      })
                    )
                  "
                />
              </td>
              <td class="inventory-actions">
                <div>
                  <p-button
                    icon="pi pi-times"
                    [rounded]="true"
                    [text]="true"
                    (click)="
                      store.dispatch(
                        actions.removeRoomButtonClicked({
                          roomId: room.id,
                        })
                      )
                    "
                  />
                </div>
              </td>
            </tr>

            <ng-container *ngIf="!room.isCollapsed">
              <tr
                class="item"
                *ngFor="let item of room.inventory; trackBy: trackByItemId"
              >
                <td class="inventory-name">{{ item.name }}</td>
                <td class="inventory-value hidden-sm">
                  <p-inputNumber
                    [ngModel]="item.quantity"
                    [min]="0"
                    [showButtons]="true"
                    buttonLayout="horizontal"
                    spinnerMode="horizontal"
                    id="quantity-{{ item.id }}"
                    [step]="1"
                    class="dynamic-width-input"
                    (ngModelChange)="
                      store.dispatch(
                        actions.itemQuantityInputChanged({
                          itemId: item.id,
                          roomId: room.id,
                          quantity: $event,
                          doFocus: 'quantity-' + item.id,
                        })
                      )
                    "
                    [autofocus]="viewModel.focus === 'quantity-' + item.id"
                    decrementButtonClass="p-button-secondary p-button-outlined"
                    incrementButtonClass="p-button-secondary p-button-outlined"
                    incrementButtonIcon="pi pi-plus"
                    decrementButtonIcon="pi pi-minus"
                  />
                </td>
                <td
                  class="inventory-value hidden-sm"
                  pTooltip="{{ item.weight }} {{ viewModel.weightUnit }}/unit"
                >
                  {{ item.totalWeight }}{{ viewModel.weightUnit }}
                </td>
                <td
                  class="inventory-value hidden-sm"
                  pTooltip="{{ item.volume }} {{ viewModel.volumeUnit }}/unit"
                >
                  {{ item.totalVolume }}{{ viewModel.volumeUnit }}
                </td>
                <td class="inventory-value show-sm">
                  {{ item.quantity }}<br />
                  {{ item.totalWeight }}{{ viewModel.weightUnit }}<br />
                  {{ item.totalVolume }}{{ viewModel.volumeUnit }}
                </td>
                <td class="inventory-actions">
                  <div>
                    <p-button
                      icon="pi pi-pencil"
                      [attr.aria-label]="'Edit item ' + item.name"
                      [rounded]="true"
                      [text]="true"
                      (click)="
                        store.dispatch(
                          actions.editItemButtonClicked({
                            itemId: item.id,
                            roomId: room.id,
                          })
                        )
                      "
                    />
                    <p-button
                      icon="pi pi-times"
                      [attr.aria-label]="'Remove item ' + item.name"
                      [rounded]="true"
                      [text]="true"
                      (click)="
                        store.dispatch(
                          actions.removeItemButtonClicked({
                            itemId: item.id,
                            roomId: room.id,
                          })
                        )
                      "
                    />
                  </div>
                </td>
              </tr>

              <tr>
                <td class="inventory-item-name add-item">
                  <p-autoComplete
                    id="item-search-{{ room.id }}"
                    [autofocus]="viewModel.focus === 'item-search-' + room.id"
                    placeholder="Add Item..."
                    [ngModel]="viewModel.inventorySearch[room.id]"
                    [suggestions]="viewModel.inventorySearchResults"
                    (completeMethod)="
                      store.dispatch(
                        actions.itemAutocompleteSearchFired({
                          query: $event.query,
                        })
                      )
                    "
                    (onSelect)="
                      store.dispatch(
                        actions.itemAutocompleteItemSelected({
                          item: $event.value,
                          roomId: room.id,
                          doFocus: 'item-search-' + room.id,
                        })
                      )
                    "
                    (onDropdownClick)="
                      store.dispatch(
                        actions.itemAutocompleteItemSelected({
                          item: $event.value,
                          roomId: room.id,
                          doFocus: 'item-search-' + room.id,
                        })
                      )
                    "
                    (onKeyUp)="
                      store.dispatch(
                        actions.itemAutocompleteInputChanged({
                          roomId: room.id,
                          value: $event.target.value,
                        })
                      )
                    "
                    (keyup.enter)="
                      store.dispatch(
                        actions.itemAutocompleteEnterPressed({
                          key: $event,
                          roomId: room.id,
                          doFocus: 'item-search-' + room.id,
                        })
                      )
                    "
                    optionLabel="reviewerName"
                  />
                </td>
                <td class="hidden-sm"></td>
                <!-- Quantity -->
                <td class="hidden-sm"></td>
                <td class="hidden-sm"></td>
                <td class="show-sm"></td>
                <td class="inventory-actions">
                  <div>
                    <p-button
                      *ngIf="viewModel.inventorySearch"
                      icon="pi pi-save"
                      [rounded]="true"
                      [text]="true"
                      tooltipPosition="left"
                      pTooltip="Add {{
                        viewModel.inventorySearchResults.length
                          ? viewModel.inventorySearchResults[0].reviewerName ||
                            viewModel.inventorySearchResults[0].label
                          : viewModel.inventorySearch[room.id]
                      }} to {{ room.name }} as custom item"
                      (click)="
                        store.dispatch(
                          actions.itemAutocompleteSaveButtonClicked({
                            roomId: room.id,
                            doFocus: 'item-search-' + room.id,
                          })
                        )
                      "
                      [disabled]="!viewModel.inventorySearch[room.id]"
                    />
                  </div>
                </td>
              </tr>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="viewModel.showAddRoomButtonAtBottom">
            <tr>
              <td colspan="7">
                <p-button
                  class="add-room-bottom-button"
                  label="Add Room"
                  icon="pi pi-plus"
                  (click)="store.dispatch(actions.addRoomButtonClicked())"
                ></p-button>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </section>

  <div class="empty-state" *ngIf="viewModel.rooms.length === 0">
    <i class="pi pi-box"></i>
    <span>This inventory is empty. Add a room to get started</span>
  </div>

  <p-dialog
    header="Add Room"
    [modal]="true"
    [visible]="viewModel.addRoomDialogVisible"
    [style]="{ width: '25rem', maxHeight: '80vh' }"
    (visibleChange)="store.dispatch(actions.exitAddRoomDialogButtonClicked())"
  >
    <div class="room-options">
      <p-button
        class="room-option"
        [autofocus]="room.focus"
        [outlined]="room.exists"
        [severity]="room.exists ? 'secondary' : 'primary'"
        *ngFor="let room of viewModel.addRoomOptions"
        (click)="
          store.dispatch(
            actions.newRoomSelected({
              name: room.name,
            })
          )
        "
      >
        Add {{ room.name }}
      </p-button>
    </div>
    <div class="room-custom-option">
      <p-floatLabel>
        <input
          id="addRoomCustom"
          type="text"
          pInputText
          [ngModel]="viewModel.customRoomName"
          (keydown.enter)="store.dispatch(actions.customRoomNameEnterPressed())"
          (ngModelChange)="
            store.dispatch(actions.customRoomNameInputChanged({ name: $event }))
          "
        />
        <label for="addRoomCustom">Add Other Room...</label>
      </p-floatLabel>
      <p-button
        icon="pi pi-plus"
        placeholder="Other..."
        severity="secondary"
        [outlined]="true"
        [disabled]="!viewModel.customRoomName"
        (click)="store.dispatch(actions.addCustomRoomButtonClicked())"
      ></p-button>
    </div>
  </p-dialog>

  <p-dialog
    header="Edit Item"
    class="edit-item-dialog"
    [modal]="true"
    [visible]="viewModel.editItemDialogVisible"
    [style]="{ width: '25rem', maxHeight: '80vh' }"
    (visibleChange)="store.dispatch(actions.exitEditItemButtonClicked())"
  >
    <div class="dialog-content">
      <div class="p-fluid form-grid">
        <!-- Name -->
        <div class="p-field p-col-12">
          <p-floatLabel>
            <input
              pInputText
              id="item-name"
              [ngModel]="viewModel.editInventoryItemDialog.name"
              (ngModelChange)="
                store.dispatch(
                  actions.editItemDialogNameInputChanged({ name: $event })
                )
              "
            />
            <label for="item-name">Name</label>
          </p-floatLabel>
        </div>

        <!-- Quantity -->
        <div class="p-field p-col-12">
          <p-floatLabel>
            <p-inputNumber
              id="item-quantity"
              [ngModel]="viewModel.editInventoryItemDialog.quantity"
              [min]="0"
              [step]="1"
              [showButtons]="true"
              (ngModelChange)="
                store.dispatch(
                  actions.editItemDialogQuantityInputChanged({
                    quantity: $event,
                  })
                )
              "
            ></p-inputNumber>
            <label for="item-quantity">Quantity</label>
          </p-floatLabel>
        </div>

        <!-- Weight -->
        <div class="p-field p-col-12">
          <p-floatLabel>
            <p-inputNumber
              id="item-weight"
              [ngModel]="viewModel.editInventoryItemDialog.weight"
              [step]="0.01"
              mode="decimal"
              (ngModelChange)="
                store.dispatch(
                  actions.editItemDialogWeightInputChanged({
                    weight: $event,
                  })
                )
              "
            ></p-inputNumber>
            <label for="item-weight">Weight ({{ viewModel.weightUnit }})</label>
          </p-floatLabel>
        </div>

        <!-- Volume -->
        <div class="p-field p-col-12">
          <p-floatLabel>
            <p-inputNumber
              id="item-volume"
              [ngModel]="viewModel.editInventoryItemDialog.volume"
              [step]="0.01"
              mode="decimal"
              (ngModelChange)="
                store.dispatch(
                  actions.editItemDialogVolumeInputChanged({
                    volume: $event,
                  })
                )
              "
            ></p-inputNumber>
            <label for="item-volume">Volume ({{ viewModel.volumeUnit }})</label>
          </p-floatLabel>
        </div>
      </div>
    </div>

    <div class="flex justify-content-end gap-2 dialog-footer">
      <p-button
        label="Cancel"
        severity="secondary"
        class="p-button-outlined"
        (onClick)="store.dispatch(actions.cancelEditItemButtonClicked())"
      />
      <p-button
        label="Save"
        class="p-button-success"
        (onClick)="store.dispatch(actions.editItemDialogAcceptButtonClicked())"
      />
    </div>
  </p-dialog>

  <ng-template #bookSmartConsultSplitButton>
    <p-splitButton
      [disabled]="
        viewModel.isCreatingSelfSurvey ||
        viewModel.isBookingYemboSmartConsult ||
        viewModel.isStartingOnsiteEstimate
      "
      class="full-width-tiered-menu"
      icon="pi pi-book"
      label="Book Yembo Smart Consult"
      (onClick)="store.dispatch(actions.bookYemboSmartConsultButtonClicked())"
      [model]="viewModel.splitMenuItems"
    />
  </ng-template>

  <ng-template #bookVideoCallButton>
    <p-button
      [loading]="viewModel.isBookingYemboSmartConsult"
      icon="pi pi-video"
      label="Book Video Call"
      (onClick)="store.dispatch(actions.bookVideoCallButtonClicked())"
    />
  </ng-template>
</ng-container>
